module.exports = __webpack_public_path__ + "img/5Y.9093ccb7.png";